/**
 * v1.14.65.0 — D&O Public Form wrapper.
 *
 * Sottile passthrough che monta `DOWizard` (11-step wizard).
 * Manteniamo questo file come entry point per non rompere le route esistenti:
 *   /do            → openMode=true
 *   /q/do/:token   → openMode=false (broker-gated invite)
 */
import React from "react";
import DOWizard from "./do/DOWizard";

export default function DOPublicFormPage({ openMode = false }) {
  return <DOWizard openMode={openMode} />;
}
